// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import Vuex from 'vuex'
import router from './router'
import { Icon, Toast,Loading } from 'vant'
import './assets/index.css'
// import { vueBaberrage } from 'vue-baberrage'
// Vue.use(vueBaberrage)
// 导入组件库
import VueCanvasPoster from 'vue-canvas-poster'
// 注册组件库
Vue.use(VueCanvasPoster)

Vue.config.productionTip = false
Vue.use(Vuex)
Vue.use(Icon)
Vue.use(Toast)
Vue.use(Loading)
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js